import styled from 'styled-components';
import { P } from 'components/theme/Typography';
import { VibeButton, TypeButton } from 'components/theme/Button';

const commonStyles = () => {
  return `
      font-style: normal;
      font-weight: normal;
      text-transform:none;
    `;
};

export const Title = styled.h3`
  ${commonStyles()};
  color: var(--way-colors-primaryTextColor);
  font-family: ${({ theme }) => theme.font.primaryFont};
  font-size: 24px;
  font-weight: normal;
  line-height: 32px;
  margin-bottom: 15px;
  margin-top: 0;
  text-transform: none;
  @media (min-width: 768px) {
    font-size: 36px;
    line-height: 44px;
  }
`;

export const Wrapper = styled.a`
  margin-bottom: 40px;
  display: flex;
  flex-direction: column-reverse;
  text-decoration: none;

  @media (min-width: 768px) {
    align-items: center;
    gap: 96px;
    margin-bottom: 24px;
    display: flex;
    flex-direction: row;
    &:nth-child(even) {
      flex-direction: row-reverse;
    }
    /* Last featured item runs into whatever section follows (divider + listings on the schedule
       view, or the next block on other pages), so the wide 87px gap reads as dead space. */
    &:last-child {
      margin-bottom: 0px;
    }
  }
`;

export const WraperContent = styled.div`
  position: relative;
  align-items: flex-start;
  justify-content: flex-start;
  display: flex;
  text-align: left;

  @media (min-width: 768px) {
    flex: 1 1 50%;
  }
`;

export const Body = styled(P)`
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 15px;
`;

export const WrapText = styled.div`
  width: 100%;
`;

export const StyledLink = styled.div`
  cursor: pointer;
  color: var(--way-colors-primaryTextColor);
`;

export const TagButtonWrap = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 7px;
`;

export const Button = styled(TypeButton)`
  margin-right: 8px;
  margin-bottom: 8px;
`;

export const ButtonGray = styled(VibeButton)`
  margin-right: 8px;
  margin-bottom: 8px;
`;

export const PriceTag = styled.div`
  margin-bottom: 15px;
  font-size: 14px;
  line-height: 17px;
`;

export const FeaturedMeta = styled.div`
  display: flex;
  align-items: center;
`;

export const FeaturedParticipantsTotal = styled.div`
  margin-right: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

export const Footer = styled.div`
  padding-bottom: 24px;
`;

export const Title4 = styled.div`
  ${commonStyles()};
  color: var(--way-colors-primaryTextColor);
  display: block;
  font-family: ${({ theme }) => theme.font.primaryFont};
  font-size: 14px;
  line-height: 17px;
  margin-bottom: 24px;
  margin-top: 0;
  @media (min-width: 768px) {
    font-size: 14px;
    font-weight: normal;
    line-height: 17px;
    margin-bottom: 15px;
  }
`;

export const HostedBy = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const HostedByImageWrap = styled.div`
  width: 48px;
  height: 48px;
  overflow: hidden;
  border-radius: 50%;
  position: relative;
  margin-right: 8px;
`;

export const HostedByContent = styled.div`
  font-size: 12px;
  line-height: 15px;
  width: calc(100% - 55px);
`;

export const DefaultUserAvatar = styled.div`
  background-color: #dedcdc6e;
  position: relative;
  width: 48px;
  height: 48px;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 8px;
  & > * {
    position: absolute;
    top: 20%;
    left: 25%;
  }
`;

export const WrapperImage = styled.div`
  position: relative;
  @media (min-width: 768px) {
    flex: 1 1 50%;
  }
`;

/* Image fills the image column, capped at 375px tall. `aspect-ratio: 4 / 3` gives the container
   a proportional height when the column is narrow (so short/portrait layouts still show a full
   tile) and `max-height: 375px` caps it on wider columns. `StyledLink` inside is forced to fill
   the frame so the absolutely-positioned StyledImage (see FeaturedImageContainer) resolves its
   `height: 100%` correctly — without this the height chain collapses to 0 at the intermediate
   StyledLink and the image disappears. Videos still use the classic padding-bottom trick because
   the video player positions itself absolutely and needs the padding-height to work against. */
export const WrapperImageRatio = styled.div<{ $isVideo?: boolean }>`
  position: relative;
  width: 100%;
  margin-bottom: 30px;
  overflow: hidden;
  ${({ $isVideo }) =>
    $isVideo
      ? 'padding-bottom: 75%;'
      : 'aspect-ratio: 4 / 3; max-height: 375px;'}

  > ${StyledLink} {
    display: block;
    width: 100%;
    height: 100%;
  }

  @media (min-width: 768px) {
    margin-bottom: 0;
  }
`;

export const VideoContentWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  & > ${StyledLink} {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
`;
